import type { CSSObject } from "type/tss";
import { baseColors } from "theme";

export const styles = () => {
	return {
		badge: {
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			minWidth: 16,
			height: 16,
			padding: "0 4px",
			boxSizing: "border-box",
			borderRadius: 8,
			backgroundColor: baseColors.teal500,
			color: baseColors.white,
			fontSize: 10,
			fontWeight: 700,
			lineHeight: 1,
		},
	} satisfies Record<string, CSSObject>;
};
